module.exports = __webpack_public_path__ + "static/media/largeDeliveryTruck_turquoise.0e4d30a0.svg";